import React from "react";

export default function TermoPolitica() {
  
  return (
    <>
      <h6>POLÍTICAS DE PRIVACIDADE</h6>
      <p>
        Esta política de privacidade (“Política”) descreve como GUPPY
        CRIATIVIDADE E TECNOLOGIA LTDA ('Empresa', 'nós' e 'nosso')
        procede, recolhe, usa e partilha informação pessoal quando usa
        nossos sites e plataformas. Por favor, leia a informação
        abaixo cuidadosamente para que possa entender as nossas
        praticas relativamente como lidamos com a sua informação
        pessoal e como tratamos essa informação.
      </p>
      <p>
        <strong>Glossário</strong>
      </p>
      <p>
        i) Cliente: usuário que adquiri nossos cursos cadastrados nas
        plataformas e grupos AUTOBET VIRTUAL.
      </p>
      <p>ii) Cursos: conteúdo adquirido pelo CLIENTE com a compra</p>
      <p>
        iii) Cadastro: procedimento pelo qual o CLIENTE fornece seus
        dados cadastrais a AUTOBET VIRTUAL de modo a adquirir acesso
        aos nossos cursos e sistemas.
      </p>
      <p>
        iv) Produtos: conteúdo a ser adquirido através da compra junto
        à empresa intermediadora.
      </p>
      <p>
        v) Aplicativo de contato: rede social própria utilizada para
        contato com os CLIENTES e formação do grupo de dicas e
        informações.
      </p>
      <p>
        vi) COOKIES: pequenos arquivos de computador ou pacotes de
        dados enviados por um site da Internet para o navegador do
        usuário, quando o CLIENTE visita o site/plataforma.
      </p>
      <p>
        vii) IP: abreviatura de Internet Protocol. É conjunto
        alfanumérico que identifica os dispositivos dos CLIENTES na
        Internet;
      </p>
      <p>
        viii) DADOS PESSOAIS: informação relativa a uma pessoa
        singular identificada ou identificável;
      </p>
      <p>
        ix) DADOS SENSÍVEIS: informações da pessoa singular com
        potencial discriminatório, como, por exemplo, dados genéticos,
        dados biométricos tratados simplesmente para identificar um
        ser humano, dados relacionados com a saúde, dados relativos à
        vida sexual ou orientação sexual da pessoa;
      </p>
      <p>
        x) ELIMINAÇÃO: exclusão permanente das informações coletadas.
      </p>
      <p>
        xi) TERCEIRO: a pessoa singular ou coletiva, a autoridade
        pública, o serviço ou organismo que não seja o titular dos
        dados, o responsável pelo tratamento, o subcontratante e as
        pessoas que, sob a autoridade direta do responsável pelo
        tratamento ou do subcontratante, estão autorizadas a tratar os
        dados pessoais;
      </p>
      <p>
        xii) CONSENTIMENTO DO TITULAR DOS DADOS: manifestação de
        vontade, livre, específica, informada e explícita, pela qual o
        titular dos dados aceita, mediante declaração ou ato positivo
        inequívoco, que os dados pessoais que lhe dizem respeito sejam
        objeto de tratamento.
      </p>
      <p>
        <strong>1. FINALIDADE DO PROCESSAMENTO</strong>
      </p>
      <p>
        1.1. O que são dados pessoais?
        <br />
        Os dados pessoais são aqueles informados pelos CLIENTES, os
        quais podem ser usados para identificar os CLIENTES,
        individualmente. Esses incluem qualquer informação, que
        combinada com mais dados ou não identifica o CLIENTE como um
        indivíduo, como por exemplo, o seu nome, código postal, e-mail
        e telefone.
      </p>
      <p>
        1.2. Autorização de Coleta de Informações: Ao utilizar a
        plataforma, você deverá aceitar e autorizar a coleta de
        informações apenas para o cumprimento dos serviços ora
        contratados, nos termos da presente política de privacidade.
      </p>
      <p>
        1.3. Por que precisamos desta informação pessoal? Somente
        processaremos os seus dados pessoais de acordo com as leis de
        proteção dedados e privacidade aplicáveis. Precisamos de
        certos dados pessoais para fornecer-lhe acesso ao site e/ou
        plataforma. Este consentimento nos fornece a base legal que
        exigimos sob a lei aplicável para processar os seus dados.
        Você mantém o direito de retirar tal consentimento a qualquer
        momento. Se você não concordar com o uso dos seus dados
        pessoais de acordo com esta Política, basta envia e-mail ao
        suporte da AUTOBET VIRTUAL que entraremos em contato.
      </p>
      <p>
        1.4. Regulamentação? A Plataforma atua de acordo com a
        legislação brasileira, atendendo, inclusive e especialmente,
        com os termos da Lei nº. 12.965/2014 (o Marco Civil da
        Internet) e da Lei nº 13.709/2018 (Lei Geral de Proteção de
        Dados) e demais leis que venham a ser aplicadas.
      </p>
      <p>
        <strong>2. RECOLHENDO OS SEUS DADOS PESSOAIS</strong>
      </p>
      <p>
        2.1. Nós recolhemos informações sobre das seguintes formas:
        Informações que você nos dá. Inclui:
      </p>
      <ul>
        <li>
          Os dados pessoais que você fornece quando se registra para
          usar o nosso website/plataforma, incluindo seu nome, cpf,
          endereço, e-mail, número de telefone, nome de usuário, senha
          e informações demográficas;
        </li>
        <li>
          Os dados pessoais que podem estar contidos em qualquer
          comentário ou outra publicação que você no nosso
          website/plataforma;
        </li>
        <li>
          Os dados pessoais que você fornece no nosso programa de
          afiliados ou em outras promoções que corremos no nosso
          website/plataforma;
        </li>
        <li>
          Os dados pessoais que você fornece quando reporta um
          problema no nosso website ou quando necessita de suporte ao
          cliente;
        </li>
        <li>
          Os dados pessoais que você fornece quando faz compras junto
          à empresa intermediadora;
        </li>
        <li>
          Os dados pessoais que você fornece quando nos contata por
          telefone, e-mail ou de outra forma.
        </li>
      </ul>
      <p>2.2. Informações que recolhemos automaticamente.</p>
      <p>
        2.2.1. Registramos automaticamente informações sobre si e o
        seu computador, ou dispositivo móvel quando você acessa o
        nosso website/plataforma. Por exemplo, ao visitar o nosso
        website, registramos o nome e a versão do seu computador, ou
        dispositivo móvel, o fabricante e o modelo, o tipo de
        navegador, o idioma do navegador, a resolução do ecrã, o
        website visitado antes de entrar no nosso website, as páginas
        visualizadas e por quanto tempo você esteve em uma página,
        tempos de acesso e informações sobre o seu uso e ações no
        nosso website/plataforma. Recolhemos informações sobre si
        usando cookies.
      </p>
      <p>
        2.2.2. É necessária a aceitação do CLIENTE, antes de iniciada
        a seção, para que os Cookies sejam utilizados.
      </p>
      <p>
        <strong>3. COOKIES</strong>
      </p>
      <p>
        3.1. O que são cookies? Podemos recolher informação sua usando
        'cookies'. Cookies são pequenos arquivos de dados armazenados
        no disco rígido do seu computador, ou dispositivo móvel no seu
        browser. Podemos usar tanto cookies (que expiram depois de
        fechar o browser) como cookies sem data de expiração (que
        ficam no seu computador, ou dispositivo móvel até que você os
        apague) para fornecer-lhe uma experiência mais pessoal e
        interativa no nosso website.
      </p>
      <p>
        3.2. Cookies que utilizamos O nosso website/plataforma utiliza
        os seguintes cookies descritos abaixo:
      </p>
      <p>
        <strong>TIPO DE COOKIES</strong>
      </p>
      <p>
        <strong>Cookies essenciais</strong>
        <br />
        Estes cookies são necessários para fornecer os serviços
        disponíveis no nosso website/plataforma, para que você seja
        capaz de utilizar algumas das suas funcionalidades. Por
        exemplo, poderão permitir que você faça login na área de
        membro, ou que carregue o conteúdo do nosso website
        rapidamente. Sem estes cookies muitos dos serviços disponíveis
        no nosso website/plataforma poderão não funcionar
        corretamente, e só usamos estes cookies para providenciar-lhe
        um bom serviço.
      </p>
      <p>
        <strong>Cookies de funções</strong>
        <br />
        Este cookie permite recordar as escolhas que você já fez no
        nosso website/plataforma, como por exemplo, a língua, detalhes
        de login, assim como outras escolhas que fez que possam ser
        personalizadas por si. O propósito deste cookies é relembrar
        todas as escolhas que você fez de formar a criar uma
        experiência mais personalizada sem ter que inserir novamente
        os seus dados no nosso website/plataforma.
      </p>
      <p>
        <strong>Cookies de analise e performance</strong>
        <br />
        Estes cookies servem para recolher a informações sobre o
        tráfego do nosso website/plataforma e como os utilizadores
        utilizam e navegam no website. A informação recolhida não
        identifica em particular nenhum utilizador.
      </p>
      <p>
        Nós utilizamos estas informações para melhorar e monitorar a
        atividade do nosso website.
      </p>
      <p>
        <strong>Cookies de publicidade</strong>
        <br />
        Estes cookies analisam a forma como navega para podermos
        mostrar-lhe anúncios que provavelmente serão do seu interesse.
        Este cookies utilizam a informação do seu histórico de
        navegação que com a sua permissão mostra-lhe anúncios
        relevantes de terceiros, baseado nos seus interesses.
      </p>
      <p>
        <strong>Cookies de redes sociais</strong>
        <br />
        Estes cookies são utilizados quando você partilha informação
        nas redes sociais, ou de alguma forma tem acesso aos nossos
        conteúdos através das redes sociais como o Facebook,
        Instagram, Twitter, ou Google+.
      </p>
      <p>
        3.3. Desabilitando os cookies
        <br />O CLIENTE pode remover, ou rejeitar cookies através das
        configurações do browser. Para fazer isso recomendamos que
        siga as instruções dos seus browsers (normalmente pode
        encontrar estas informações nas “configurações” do seu browser
        em “ajuda”, ou “ferramentas”).
      </p>
      <p>
        Se não aceitar os nossos cookies, a sua experiência no nosso
        site/plataforma não será tão agradável. Por exemplo, nós
        poderemos não reconhecer o seu computador, ou dispositivo
        móvel e você poderá ter que fazer login sempre que entrar no
        nosso website/plataforma.
      </p>
      <p>
        <strong>4. PUBLICIDADE</strong>
        <br />A AUTOBET VIRTUAL poderá utilizar terceiros para
        apresentar anúncios quando visita o nosso website/plataforma.
        Estas empresas poderão recolher informações como, tipo de
        browser, hora e dia, tipo de anúncio foi clicado, neste e
        outros websites de forma amostrar os anúncios mais relevantes
        a você. Estas empresas normalmente utilizam o seu sistema para
        recolher estes dados, que estão sujeitos às políticas de
        privacidade daquela, não havendo responsabilidade nossa sobre
        tal.
      </p>
      <p>
        <strong>5. USANDO OS SEUS DADOS PESSOAIS</strong>
      </p>
      <p>
        5.1. Nós poderemos utilizar os seus dados pessoais da seguinte
        forma:
      </p>
      <ul>
        <li>
          Para manter e melhorar o nosso website, produtos e serviços;
        </li>
        <li>
          Para gerir a sua conta, incluindo comunicações que temos
          consigo relativamente à sua conta.
        </li>
        <li>
          Para operar e administrar o nosso programa de afiliados e
          outras promoções que você poderá participar no nosso
          website;
        </li>
        <li>
          Para responder aos seus comentários e perguntas e para
          prestar apoio ao cliente;
        </li>
        <li>
          Para enviar informações, incluindo informação técnica,
          atualizações, alertas de segurança e suporte; com o seu
          consentimento, fazemos e-mail marketing sobre promoções, e
          outras novidades, incluindo informação sobre os nossos
          produtos, ou serviços oferecidos por nós, ou pelos nossos
          afiliados.
        </li>
      </ul>
      <p>
        5.2. Você poderá deixar de receber estas informações a
        qualquer momento, em todos os nossos e-mails tem sempre uma
        opção de sair da lista.
      </p>
      <p>
        5.3. Informamos que, ainda com a saída da lista poderemos
        enviar e-mails não relacionados com marketing, a citar
        exemplo: incluem e-mails sobre alguma conta que tenha com a
        AUTOBET VIRTUAL; e-mails de negócios; processamento de
        pagamentos; para avisos e envio de NOTIFICAÇÕES EXTRAJUDICIAS;
        para cumprir a lei; para cumprir demandas ou interpelações
        judiciais; para cumprir a presente POLÍTICA DEPRIVACIDADE;
        para proteger direitos, entre outros.
      </p>
      <p>
        <strong>6. PARTILHAR OS SEUS DADOS PESSOAIS</strong>
      </p>
      <p>
        6.1. Podemos partilhar os seus dados pessoais das seguintes
        formas:
      </p>
      <ul>
        <li>
          A terceiros designados pelo CLIENTE. Podemos partilhar os
          seus dados com terceiros em que o CLIENTE tenha dado o seu
          consentimento.
        </li>
        <li>
          Poderemos partilhar os seus dados pessoais com terceiros que
          realizam alguns serviços como (analise de dados,
          processamento de pagamentos, suporte ao cliente, envio de
          e-mail marketing e outros serviços similares).
        </li>
        <li>
          Casos em que a GUPPY CRIATIVIDADE E TECNOLOGIA LTDA for
          obrigada a divulgar ou partilhar os dados coletados, a fim
          de cumprir ordem judicial, ou para efeitos de prevenção de
          fraude ou outros crimes, bem como em resposta à solicitação
          de informações apresentada por autoridade competente, se
          entendermos que a divulgação está de acordo ou é exigida
          conforme as leis, regulamentos ou procedimentos processuais
          aplicáveis;
        </li>
        <li>
          Para proteger os direitos, bens ou a segurança da AUTOBET
          VIRTUAL e da Plataforma;
        </li>
        <li>
          Com agentes da lei e/ou autoridades governamentais, se
          entender-se que suas ações são inconsistentes em relação às
          disposições em nossos termos de uso, ou para proteger os
          direitos, a propriedade ou a segurança da AUTOBET VIRTUAL,
          de seus CLIENTES, ou de outros;
        </li>
        <li>
          Nos casos de venda, parcial ou total, do negócio ou de seus
          ativos, ou como parte de qualquer reorganização ou
          reestruturação do negócio, fusão, cisão ou incorporação, de
          modo que a AUTOBET VIRTUAL poderá compartilhar as
          informações dos Usuários com terceiros que façam parte dos
          respectivos negócios, tomando as medidas necessárias para
          garantir que os direitos de privacidade continuem a ser
          protegidos, conforme esta Política.
        </li>
        <li>
          Com a Firebase para hospedar alguns dados e funcionalidades
          da Plataforma.
        </li>
      </ul>
      <p>
        6.2. Proteção de senhas <br />
        Os CLIENTES são igualmente responsáveis por tomar medidas
        cabíveis destinadas a proteger as suas senhas, nomes de
        usuário e outros recursos de acesso especiais ao cadastro
        pessoal na GUPPY CRIATIVIDADE E TECNOLOGIA LTDA.
      </p>
      <p>
        <strong>7. WEBSITE DE TERCEIROS</strong>
      </p>
      <p>
        7.1. O nosso website poderá conter links de terceiros. Esta
        Política não cobre as Políticas de privacidade de terceiros.
        Estes websites de terceiros tem as suas próprias políticas de
        privacidade, não havendo qualquer responsabilidade da AUTOBET
        VIRTUAL sobre isso.
      </p>
      <p>
        <strong>8. CONTEÚDO GERADO PELO UTILIZADOR</strong>
      </p>
      <p>
        8.1. O CLIENTE poderá partilhar os seus dados pessoais conosco
        quando submete e gera conteúdo no nosso website/plataforma,
        incluem-se comentários no blog, mensagens de suporte no nosso
        website.
      </p>
      <p>
        8.2. Qualquer informação que o CLIENTE publique no nosso
        website/plataforma torna-se de conhecimento publico e ficará
        acessível a todos os usuários do nosso website incluindo
        visitantes, não podendo haver quaisquer responsabilidade da
        AUTOBET VIRTUAL sobre essas informações.
      </p>
      <p>
        <strong>9. TRANSFERÊNCIA DE DADOS INTERNACIONAL</strong>
      </p>
      <p>
        9.1. As suas informações incluindo dados pessoais que
        recolhemos de você, poderão ser transferidos para, guardado
        em, e processado por nós fora do país onde você reside, onde
        proteção de dados e regulamentos de privacidade poderão não
        ter o mesmo nível de proteção como em outros países. O
        procedimento seguirá a regras do art. 33 da Lei Geral de
        Proteção de Dados.
      </p>
      <p>
        9.2. A AUTOBET VIRTUAL irá tomar todas medidas necessárias
        para assegurar que os seus dados são tratados da forma mais
        segura e de acordo com as nossas políticas.
      </p>
      <p>
        <strong>10. SEGURANÇA</strong>
      </p>
      <p>
        10.1. Procuramos tomar sempre todas as medidas, técnicas e
        administrativas para proteger todos os seus dados da forma
        mais segura possível. Infelizmente nenhum sistema é 100%
        seguro e poderá garantir completamente a segurança dos seus
        dados, não podendo haver responsabilização da AUTOBET VIRTUAL
        por fato de terceiros, força maior, caso fortuito em relação a
        vazamento de dados, por exemplo, ataque de HACKERS.
      </p>
      <p>
        10.2. Os dados pessoais das contas dos CLIENTES são
        armazenados de forma segura, todas as informações da
        plataforma trafegam de forma segura, sendo que apenas os
        colaboradores autorizados pela AUTOBET VIRTUAL CORPORATE LTDA
        podem ter acesso às suas informações pessoais, estando
        obrigatoriamente sujeitos aos deveres de confidencialidade e
        rigoroso respeito à sua privacidade nos termos desta Política.
      </p>
      <p>
        <strong>11. RESPONSABILIDADES</strong>
      </p>
      <p>
        11.1. Os CLIENTES serão responsáveis por indenizar a AUTOBET
        VIRTUAL por todos os custos e danos que este possa incorrer,
        como resultado da violação desta Política de Privacidade.
      </p>
      <p>
        11.2. Esta Política de Privacidade aborda apenas o uso e
        divulgação de informações coletadas pela Plataforma da AUTOBET
        VIRTUAL. Se os CLIENTES divulgarem suas informações a websites
        de terceiros, regras diferentes podem ser aplicadas à sua
        utilização das informações.
      </p>
      <p>
        <strong>
          12. ALTERAÇÕES DESSA POLÍTICA DE PRIVACIDADE E COMUNICAÇÕES
        </strong>
      </p>
      <p>
        12.1. A AUTOBET VIRTUAL pode alterar a Política de Privacidade
        da Plataforma/site de tempo sem tempos. O uso de informações
        coletadas agora está sujeito à Política de Privacidade em
        vigor. Se a AUTOBET VIRTUAL realizar mudanças na forma como
        utiliza as informações pessoais, haverá notificação aos
        CLIENTES.
      </p>
      <p>
        12.2. Pequenos ajustes nesta Política de Privacidade podem
        ocorrer sem afetar significativamente as formas em que a
        AUTOBET VIRTUAL trata as informações coletadas, deforma que
        estes não precisarão ser informados.
      </p>
      <p>
        12.3. Os CLIENTES, ao se cadastrarem, concordam que a AUTOBET
        VIRTUAL envie para o seu e-mail notificações, publicidades,
        novidades sobre os serviços e informações importantes sobre a
        utilização da Plataforma que necessitem da sua atenção.
      </p>
      <p>13. DIREITOS DOS CLIENTES</p>
      <p>
        13.1. Os CLIENTES têm direito de solicitar a exclusão dos seus
        dados pessoais armazenados na AUTOBET VIRTUAL, a qualquer
        momento, salvo nos casos em que houver obrigação legal ou
        decisão judicial para a manutenção do armazenamento dos dados,
        de acordo com o disposto nos artigos 18, XVI, e 16 da LGPD.
      </p>
      <p>
        13.2. OS CLIENTES têm direito podem a qualquer momento
        solicitar a saída das listas de comunicações, e-mails de
        marketing, da recolha de dados pessoais sensíveis, de qualquer
        novo processamento de dados pessoais.
      </p>
      <p>
        13.3. OS CLIENTES podem ter acesso as suas informações
        armazenadas em nossos bancos de dados a qualquer momento.
      </p>
      <p>
        13.4. OS CLIENTES poderão solicitar alteração ou correção de
        seus dados.
      </p>
      <p>
        13.5 Garantem-se aos CLIENTES os demais direitos contidos no
        art. 18 da Lei Geral de Proteção de Dados.
      </p>
      <p>14. INFORMAÇÕES DE CONTATO</p>
      <p>
        14.1. Em caso de dúvidas, reclamações ou sugestões o suporte
        da AUTOBET VIRTUAL poderá ser contatado através do e-mail:
        contato@autobetvirtual.com.br, havendo prazo de 01 (um) a 02
        (dois) dias úteis para respostas.
      </p>
      <p>ATUALIZAÇÃO: 07 DE AGOSTO DE 2022</p>
    </>
  );
}